// extracted by mini-css-extract-plugin
export var progressContainer = "_ip-0";